<template>
  <input ref="amount" class="form-control" :lang="numberLocale" :type="numberInputType" :inputmode="numberInputMode" :step="selectedStep ? selectedStep : 'any'" v-model="selectedAmount" :placeholder="placeholder" @focus="$event.target.select()" @keyup.enter="finish" />
</template>

<script>

import { mapGetters } from 'vuex'
import formats from '~/lib/formats'

export default {
  props: ['modelValue', 'placeholder', 'step'],
  mixins: [formats],
  computed: {
    ...mapGetters(['allSettings', 'shopId', 'locale']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    selectedAmount: {
      get () {
        return this.modelValue ? this.modelValue.toString() : ''
      },
      set (inputValue) {
        let newValue = String(inputValue ?? '').replace(',', '.')
        if (newValue && newValue !== '-0' && newValue !== '-') {
          newValue = parseFloat(newValue.replace(/[^\d\.]g/, ''))
          if (isNaN(newValue)) {
            newValue = 0
          }
          this.$emit('update:modelValue', '' + newValue)
        }
      }
    },
    numberInputType () {
      return (this.isIOS ? 'number' : 'text')
    },
    numberInputMode () {
      return (this.isIOS ? '' : 'numeric')
    },
    selectedStep () {
      if (this.step) {
        return this.step
      }
      return 'any' // Used to be 0.01
    },
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    }
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    focusAndSelect () {
      this.$refs.amount.focus()
      this.$refs.amount.select()
    },
    finish () {
      this.$emit('finish')
    }
  }
}
</script>
